/**
 * 首页自动导航组件
 * 当用户访问根路径时，自动导航到其有权限的第一个菜单页面
 */

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

const AutoMenuNavigator: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNavigating, setIsNavigating] = React.useState(false);

  useEffect(() => {
    // 只在根路径下执行自动导航
    if (location.pathname !== '/') {
      return;
    }

    const checkAndNavigate = () => {
      // 检查权限快照是否已加载（表示权限已准备好）
      const permissionSnapshot = localStorage.getItem('permissionSnapshot');
      const firstMenuPath = localStorage.getItem('firstUserMenuPath');

      if (permissionSnapshot && firstMenuPath) {
        // eslint-disable-next-line no-console
        console.log('[AutoMenuNavigator] Permissions loaded, navigating to first user menu:', firstMenuPath);
        setIsNavigating(true);
        navigate(firstMenuPath, { replace: true });
      } else {
        // 如果还没有，继续等待（权限可能还在加载）
        // eslint-disable-next-line no-console
        console.log('[AutoMenuNavigator] Waiting for permissions to load...');
      }
    };

    // 立即检查一次
    checkAndNavigate();

    // 如果还没有权限快照，设置定时器持续检查
    const permissionSnapshot = localStorage.getItem('permissionSnapshot');
    const firstPath = localStorage.getItem('firstUserMenuPath');
    if (!permissionSnapshot || !firstPath) {
      const interval = setInterval(() => {
        const retrySnapshot = localStorage.getItem('permissionSnapshot');
        const retryPath = localStorage.getItem('firstUserMenuPath');
        if (retrySnapshot && retryPath) {
          clearInterval(interval);
          // eslint-disable-next-line no-console
          console.log('[AutoMenuNavigator] Permissions loaded, navigating to:', retryPath);
          setIsNavigating(true);
          navigate(retryPath, { replace: true });
        }
      }, 500); // 每500ms检查一次

      // 10秒后超时，停止检查
      const timeout = setTimeout(() => {
        clearInterval(interval);
        // eslint-disable-next-line no-console
        console.warn('[AutoMenuNavigator] Permission load timeout after 10 seconds');
      }, 10000);

      return () => {
        clearInterval(interval);
        clearTimeout(timeout);
      };
    }
  }, [location.pathname, navigate]);

  if (isNavigating) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return null;
};

export default AutoMenuNavigator;
